import { render, staticRenderFns } from "./invitations.modal.vue?vue&type=template&id=397b1086&scoped=true&"
import script from "./invitations.modal.vue?vue&type=script&lang=js&"
export * from "./invitations.modal.vue?vue&type=script&lang=js&"
import style0 from "./invitations.modal.vue?vue&type=style&index=0&id=397b1086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b1086",
  null
  
)

export default component.exports